var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2399_5594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2399_5594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58474 8.57766H6.49024V5.49991H5.58474V8.57766ZM6.00036 4.68091C6.14736 4.68091 6.27049 4.63241 6.36974 4.53541C6.46891 4.43841 6.51849 4.31825 6.51849 4.17491C6.51849 4.01916 6.46882 3.89175 6.36949 3.79266C6.27016 3.6935 6.14707 3.64391 6.00024 3.64391C5.84807 3.64391 5.72357 3.6935 5.62674 3.79266C5.52991 3.89175 5.48149 4.018 5.48149 4.17141C5.48149 4.31766 5.53124 4.43916 5.63074 4.53591C5.73016 4.63258 5.85336 4.68091 6.00036 4.68091ZM6.00424 11.1765C5.28591 11.1765 4.61299 11.0416 3.98549 10.7717C3.35799 10.5017 2.80907 10.1315 2.33874 9.66116C1.86841 9.19083 1.49824 8.64195 1.22824 8.01454C0.958323 7.38704 0.823364 6.71375 0.823364 5.99466C0.823364 5.27558 0.958323 4.60195 1.22824 3.97379C1.49824 3.3457 1.86803 2.79845 2.33761 2.33204C2.8072 1.86562 3.35591 1.49637 3.98374 1.22429C4.61157 0.952204 5.2852 0.816162 6.00461 0.816162C6.72411 0.816162 7.3982 0.952037 8.02686 1.22379C8.65561 1.49545 9.20299 1.8642 9.66899 2.33004C10.1351 2.79579 10.504 3.3435 10.7759 3.97316C11.0478 4.60283 11.1837 5.27729 11.1837 5.99654C11.1837 6.71562 11.0477 7.38887 10.7756 8.01629C10.5035 8.6437 10.1343 9.19154 9.66786 9.65979C9.20145 10.128 8.65386 10.4978 8.02511 10.7693C7.39628 11.0408 6.72266 11.1765 6.00424 11.1765Z",
    fill: "#D78014"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOrange);
export default __webpack_public_path__ + "static/media/info_orange.50dda079bc240d787d648c7e0737c43e.svg";
export { ForwardRef as ReactComponent };